export default "__VITE_ASSET__CDbe5_FA__"